import React, { Component } from "react";
import ReactToPrint from 'react-to-print';
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import history from "../../../../../history/history";
import { getPrimaryAccount } from "../../../../../utils/sessionUtil";
import { milliToDate, dateFormatter } from "../../../../../utils/commonUtil";
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";
import { ContentProvider, ContentMessage, Types } from '../../../../../CommonComponents/ContentMessages';
import {
  Heading,
  SpaceBetween,
  DFlex,
  DFlexWrap,
  DItems,
  VLine,
  HLine,
  GhostButtonDiv,
  PrimaryButtonDiv,
  SectionHeading,
  PrintButton,
  PrintDiv,
  PrintSection,
  HLineMob,
  DTxnId
} from "./styles";
import {
  PagesHeading,
  FixedWidth,
  DataHeading,
  DisplayFlex,
  GhostButtonComponent
} from "../../../../../CommonComponents/commonStyles";
/** Sub Components **/
import pencil from "../../../../../assets/icons/edit.svg";
import printIcon from "../../../../../assets/icons/print.svg";
import BreadcrumbComponent from "../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import SoftAlert from "../../../../../CommonComponents/Info/SoftAlert/SoftAlert.js";
import ViewAndEditFromTable from "./ViewAndEditFromTable/ViewAndEditFromTable";
import { CapsuleButton } from "../../../../../CommonComponents/Commons/commonComponents";

/** ----------------------------------------- **/

function breadcrumbRoutesView() {
  return [
    {
      routeName: "Home",
      path: "/#"
    },
    {
      routeName: "Investments",
      path: "/investments"
    },
    {
      routeName: "Exchange Activity",
      path: "/investments/exchange-activity"
    },
    {
      routeName: "View and Edit Exchange",
      path: ""
    }
  ];
}

function breadcrumbRoutesCreate() {
  return [
    {
      routeName: "Home",
      path: "/#"
    },
    {
      routeName: "Investments",
      path: "/investments"
    },
    {
      routeName: "Recommend an Exchange",
      path: ""
    }
  ];
}

export default class TIFFViewAndEditFrom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.match.params.type,
      id: this.props.match.params.id
    };
    window.scrollTo(0, 0);
  }

  componentDidMount = () => {
    const { id } = this.state;
    /** Add FROM before of findSingleExchangeDetailsByAccountIdAndExchangeId for distinguishing in mock JSON's **/
    this.props.getData({
      method: "GET",
      page: "ViewAndEditInto",
      url: `/donor-portal/api/exchange/${
        getPrimaryAccount().userId
        }/findSingleExchangeDetailsByAccountIdAndExchangeId?exchangeId=${id}`
    });
    this.props.getExchangeDate({
      method: "GET",
      page: "ViewAndEditInto",
      url: `/api/dates?Page=Expected_Exchange_Date`,
      isExternal: true
    });
    window.scrollTo(0, 0);
  };
  stepOne = () => {
    try {
      initiateTracking('edit', "View and Edit Exchange", "Amount to be exchanged from TIFF", `Edit - TIFF Exchange FROM`);
      this.props.history.push({
        pathname: `/edit-tiff`,
        params: { option: "exchangeFromTIFF", id: this.state.id, type: this.state.type }
      });
    } catch (error) {
      recordError(error);
    }
  };
  stepTwo = () => {
    try {
      initiateTracking('edit', 'View and Edit Exchange', "Recommend exchange to", `Edit - TIFF Exchange FROM`);
      this.props.history.push({
        pathname: `/edit-tiff/to`,
        params: { option: "exchangeFromTIFF", id: this.state.id, type: this.state.type }
      });
    } catch (error) {
      recordError(error);
    }
  };
  calculateFee = () => {
    const { poolFeePercentage = 0 } = this.props.getTiffDetails;
    const num = parseFloat(this.props.exchangeAmount);
    const final = (num * poolFeePercentage) / 100;
    return (
      "$" +
      Number(final).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  };
  getActualFee = (fromArr) => {
    if(fromArr && fromArr.length >0){
      const feeData = fromArr.filter(item => item.fee === true);
      if(feeData.length > 0){
        return ("$" +  Number(feeData[0].value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }))
      } else {
        return this.calculateFee();
      }
    }
   
  }
  render() {
    const { type, id } = this.state;
    const {
      getTiffDetails,
      getTiffDetailsLoader,
      expectedEchangeDate,
      expectedEchangeDateLoader,
      exchangeAmount
    } = this.props;
    const PrintText = props => {
      return (
        <PrintButton onClick={() => initiateTracking("print", `${type === "confirmation" ? "Exchange Request Confirmation" : type === "view" ? "View Exchange" : "View and Edit Exchange"}`, "", "Print - TIFF Exchange FROM")}>{props.children}</PrintButton>
      )
    };
    if (getTiffDetailsLoader || expectedEchangeDateLoader) return <Preloader />;
    return (
      <FixedWidth>
        <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_DISCLAIMERS]} pages={['Tiff Exchange', 'Tiff Confirmation']}>
          <BreadcrumbComponent breadcrumbRoutes={type === "confirmation" ? breadcrumbRoutesCreate() : breadcrumbRoutesView()} />
          <div ref={el => (this.componentRef = el)}>
            <PagesHeading className="mb-30">
              {type === "confirmation" ? <
                ContentMessage
                page='Tiff Confirmation'
                type={Types.PAGE_TITLE_DESCRIPTION}
                property='field_page_title'
                defaultMessage="Exchange request confirmation" />
                : `Transaction ID: ${getTiffDetails.transactionId}`}
            </PagesHeading>
            <SoftAlert
              className="mt-30 mb-50"
              heading={(getTiffDetails.status !== 'Completed' && getTiffDetails.status !== 'Cancelled') ? "Expected Exchange Date: " : ''}
              //date={this.props.expectedEchangeDate[0].field_date}
              date={(getTiffDetails.status !== 'Completed' && getTiffDetails.status !== 'Cancelled') && this.props.expectedEchangeDate[0].field_date}
              mainbody={<
                ContentMessage
                page='Tiff Exchange'
                type={Types.PAGE_DISCLAIMERS}
                property='field_disclaimer_content'
                html
                defaultMessage="If you would like to transfer the entire balance out of TIFF please submit your request at least 48 business hours in advance. If the request is received and the timeframe is less than 48 hours, we will do our best to accommodate the request as soon as possible. Exchanges take two business days to complete, and transaction details will post to the account by the third business day." />
              }
            />

            {/** Section 1 **/}
            <PrintSection>
              <div>
                <DisplayFlex className="mb-xs-05">
                  <DataHeading>Transaction ID:</DataHeading>
                  <Heading className="ml-10">
                    {getTiffDetails.transactionId}
                  </Heading>
                </DisplayFlex>

                <DTxnId>
                  <DisplayFlex className="mb-xs-05">
                    <DataHeading>Entered date:</DataHeading>
                    <Heading className="ml-10">
                      {milliToDate(getTiffDetails.enteredDate)}
                    </Heading>
                  </DisplayFlex>
                  <VLine />
                  <DisplayFlex className="mb-xs-05">
                    <DataHeading>{(getTiffDetails.status === 'Completed' || getTiffDetails.status === 'Cancelled') ? 'Trade date:' : 'Expected exchange date:'}</DataHeading>
                    <Heading className="ml-10">
                      {/* {expectedEchangeDate[0].field_date} */}
                      {(getTiffDetails.status === 'Completed') && dateFormatter(getTiffDetails.tradeDate)}
                      {(getTiffDetails.status === 'Cancelled') &&  <div>&mdash;</div> }
                      {(getTiffDetails.status !== 'Completed' && getTiffDetails.status !== 'Cancelled') && expectedEchangeDate[0].field_date}
                    </Heading>
                  </DisplayFlex>
                </DTxnId>
              </div>

              <ReactToPrint className="i_print"
                trigger={() => (<PrintDiv>
                  <DisplayFlex className="hide-for-print">
                    <img src={printIcon} alt="print"/>
                    <PrintText>PRINT</PrintText>
                  </DisplayFlex>
                </PrintDiv>)}
                content={() => this.componentRef}
                bodyClass="pl2"
              />
            </PrintSection>

            <HLine />

            {/** Section 2 **/}
            <SectionHeading>Investment option exchange</SectionHeading>
            <DFlexWrap>
              <DItems>
                <DataHeading>Schedule type</DataHeading>
                <Heading className="mt-05">TIFF Exchange</Heading>
              </DItems>
              <DItems>
                <DataHeading>Exchange type</DataHeading>
                <Heading className="mt-05">
                  Exchange From TIFF
            </Heading>
              </DItems>
            </DFlexWrap>
            <HLine />

            {/** Section 3 **/}
            <SpaceBetween>
              <SectionHeading className="mr-05">Amount to be exchanged from TIFF</SectionHeading>
              {type && type === "edit" && (
                <CapsuleButton height="23px" iconType="edit" text="Edit" onClick={this.stepOne}/>
              )}
            </SpaceBetween>
            <DataHeading>Exchange amount</DataHeading>
            <Heading className="mt-05">
              {"$" +
                Number(exchangeAmount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
            </Heading>
            <HLine />

            {/** Section 4 **/}
            <SpaceBetween>
              <SectionHeading className="mr-05">Recommend exchange to</SectionHeading>
              {type && type === "edit" && (
                <CapsuleButton height="23px" iconType="edit" text="Edit" onClick={this.stepTwo}/>
              )}
            </SpaceBetween>
            <ViewAndEditFromTable dataSource={getTiffDetails} />

            <HLineMob />
            <Heading className="mt-30 mb-50 xs-center">
              Applicable fee amount: {this.getActualFee(getTiffDetails.exchangeFrom)}
            </Heading>
          </div>
          <HLine />
          {type === "confirmation" ? (
            <DFlex>
              <GhostButtonDiv onClick={() => history.push("/")}>
                GO TO ACCOUNT SUMMARY
          </GhostButtonDiv>
              <PrimaryButtonDiv
                onClick={() => history.push("/investments/exchange-activity")}
              >
                VIEW ALL EXCHANGES
          </PrimaryButtonDiv>
            </DFlex>
          ) : (
              <GhostButtonComponent width="150px" onClick={() => {
                try {
                  initiateTracking("back2", `${type === "view" ? "View Exchange" : "View and Edit Exchange"}`, "", "Back - TIFF Exchange FROM");
                  history.push("/investments/exchange-activity");
                } catch (error) {
                  recordError(error);
                }
              }}>
                BACK
              </GhostButtonComponent>
            )
          }
        </ContentProvider>
      </FixedWidth>
    );
  }
}